import React from "react";
import * as Icons from "lucide-react";
import { MapPin, Mail, Phone } from "lucide-react";
import { useContent } from "../contexts/ContentContext";

export default function Footer() {
  const { content } = useContent();
  const { company, footerLinks, socials } = content;
  return (
    <footer className="bg-[#06322d] text-slate-200">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 pt-16 pb-8">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2">
              <div className="w-11 h-11 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center shadow-md">
                <Icons.Sun className="w-6 h-6 text-white" />
              </div>
              <div className="leading-none">
                <div className="text-white font-extrabold text-lg tracking-wide">{company.logoText}</div>
                <div className="text-orange-400 text-[10px] font-bold tracking-[0.25em]">{company.logoSubText}</div>
              </div>
            </div>
            <p className="mt-5 text-sm text-slate-300 leading-relaxed max-w-sm">
              {company.tagline}. Empowering Indian homes with affordable, premium solar since {company.established}.
            </p>
            <div className="mt-5 space-y-2.5 text-sm">
              <div className="flex items-start gap-2.5"><MapPin className="w-4 h-4 mt-0.5 text-orange-400 flex-shrink-0" /><span>{company.address}</span></div>
              <div className="flex items-center gap-2.5"><Phone className="w-4 h-4 text-orange-400" /><a href={`tel:${company.phone}`} className="hover:text-orange-300">{company.phone}</a></div>
              <div className="flex items-center gap-2.5"><Mail className="w-4 h-4 text-orange-400" /><a href={`mailto:${company.email}`} className="hover:text-orange-300">{company.email}</a></div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-white font-bold mb-4">Company</h4>
            <ul className="space-y-2.5 text-sm">
              {footerLinks.company.map((l) => (
                <li key={l.label}><a href={l.href} className="hover:text-orange-300">{l.label}</a></li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-2">
            <h4 className="text-white font-bold mb-4">Resources</h4>
            <ul className="space-y-2.5 text-sm">
              {footerLinks.resources.map((l) => (
                <li key={l.label}><a href={l.href} className="hover:text-orange-300">{l.label}</a></li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-2">
            <h4 className="text-white font-bold mb-4">Legal</h4>
            <ul className="space-y-2.5 text-sm">
              {footerLinks.legal.map((l) => (
                <li key={l.label}><a href={l.href} className="hover:text-orange-300">{l.label}</a></li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-2">
            <h4 className="text-white font-bold mb-4">Follow Us</h4>
            <div className="flex flex-wrap gap-2">
              {socials.map((s) => {
                const Icon = Icons[s.icon] || Icons.Globe;
                return (
                  <a key={s.name} href={s.href} aria-label={s.name} className="w-10 h-10 rounded-full bg-white/10 hover:bg-orange-500 flex items-center justify-center transition-colors">
                    <Icon className="w-4 h-4 text-white" />
                  </a>
                );
              })}
            </div>
            <div className="mt-6 px-4 py-3 rounded-lg bg-white/5 border border-white/10">
              <div className="text-xs text-slate-300">Subsidy Helpline</div>
              <div className="font-bold text-orange-300 mt-0.5">{company.whatsapp}</div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-400">
          <div>&copy; {new Date().getFullYear()} {company.name}. All rights reserved.</div>
          <div>National Approved Vendor &middot; PM Surya Ghar Muft Bijli Yojana</div>
        </div>
      </div>
    </footer>
  );
}
